const stileGrid = {
    /* boxShadow: 2, */
    border: 0,
    color: "var(--scrittaDef)",
    borderColor: 'var(--colScuro)',
    '& .MuiDataGrid-cell:hover': {
      color: 'var(--colMedio)',
    },
    hover:{
    color:'var(--scrittaColoreAlt)'
    }
  }

export default stileGrid;